import { useEffect, useRef } from 'react';

/**
 * 通知音效组件
 * 播放指定的音频文件
 */
const NotificationSound = ({ onPlay, soundFile = '/notice.mp3' }) => {
  const audioRef = useRef(null);

  useEffect(() => {
    // 创建 Audio 对象
    if (!audioRef.current) {
      audioRef.current = new Audio(soundFile);
      audioRef.current.volume = 0.5; // 设置音量为 50%
    }

    return () => {
      // 清理：停止播放并释放资源
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [soundFile]);

  const playNotificationSound = () => {
    if (!audioRef.current) return;

    try {
      // 重置播放位置
      audioRef.current.currentTime = 0;
      
      // 播放音频
      const playPromise = audioRef.current.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.warn('音频播放失败:', error);
          // 某些浏览器需要用户交互后才能播放音频
        });
      }
    } catch (error) {
      console.warn('播放通知音效失败:', error);
    }
  };

  // 暴露播放方法
  useEffect(() => {
    if (onPlay) {
      onPlay(playNotificationSound);
    }
  }, [onPlay]);

  return null;
};

export default NotificationSound;
